import { TemplateRef, ChangeDetectorRef } from '@angular/core';
import { UserService } from '../../services/user.service';
//import { MatDialog, MatSnackBar, MatPaginator, MatSort, PageEvent, MatTableDataSource, Sort, MatStepper } from '@angular/material';
import { MatDialog, MatSnackBar } from '@angular/material';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { PerfilComponent } from './../perfil/perfil.component';
import { FormControl, Validators, FormBuilder } from '@angular/forms';
import { FormService } from 'src/app/services/form.service';
import { Router, ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { registerLocaleData } from '@angular/common';
import es from '@angular/common/locales/es';
import { Seguimiento_cert_Service } from 'src/app/services/seguimiento_cert.service';
/*
export interface seg_elements {
    //rut: string;
    num_solicitud: string;
}
*/
var Seguimiento_certificadoComponent = /** @class */ (function () {
    function Seguimiento_certificadoComponent(_route, _router, _formBuilder, _userService, spinner, dialog, _formService, _certService, snackBar, _cd, _snackBar) {
        this._route = _route;
        this._router = _router;
        this._formBuilder = _formBuilder;
        this._userService = _userService;
        this.spinner = spinner;
        this.dialog = dialog;
        this._formService = _formService;
        this._certService = _certService;
        this.snackBar = snackBar;
        this._cd = _cd;
        this._snackBar = _snackBar;
        this.displayedColumns = ['solicitud', 'tipo', 'descripcion', 'detalle'];
        this.temp_dir = "a";
        this.isopen = false;
        this.matcher = new FormService();
        //public licitaciones = [];
        this.rows = [];
        this.seguim_certif = [];
        this.p = 1;
        this.arquitecto = false;
        this.rechazada = false;
        this.estatus = false;
        this.estatus_aprob = false;
        this.fechaacta = false;
        this.fechareingreso = false;
        this.aprobacion = false;
        this.pageSizeOptions = [5, 10, 25, 100];
        /* pageEvent: PageEvent;*/
        this.idSolicitud = new FormControl('', Validators.compose([Validators.required, Validators.pattern('[0-9]+')]));
        this.idEncontrado = false;
        this.seguim_cert = { num_solicitud: '', rol: '', tipo: '', direccion: '', fecha_ingreso: null, estado: '', descripcion: '', recordId: '', estado_web: '' };
        //this.informacion = JSON.parse(sessionStorage.getItem("identity-domCloud"));
        //this.rut_solic = this.informacion.rut + "-" + this.informacion.dv;
        //this.rut = this.rut_solic;
        if (!JSON.parse(localStorage.getItem("solicitud_cert"))) {
            localStorage.setItem("solicitud_cert", JSON.stringify(this.rows));
        }
        else {
            this.rows = JSON.parse(localStorage.getItem("solicitud_cert"));
        }
        // this.get_solicitudes();
        registerLocaleData(es);
    }
    Seguimiento_certificadoComponent.prototype.ngOnInit = function () {
        console.log('init!!');
        //this.get_solicitudes(this.rut_solic);
        // this.dialog.open(this.openModal);
    };
    Seguimiento_certificadoComponent.prototype.getCleanedString = function (cadena) {
        // Definimos los caracteres que queremos eliminar
        var specialChars = "!@#$^&%*()+=-[]\/{}|:<>?,.";
        // Los eliminamos todos
        for (var i = 0; i < specialChars.length; i++) {
            cadena = cadena.replace(new RegExp("\\" + specialChars[i], 'gi'), '');
        }
        // Lo queremos devolver limpio en mayuscula
        cadena = cadena.toLowerCase();
        // Quitamos espacios y los sustituimos por _ porque nos gusta mas asi
        // cadena = cadena.replace(/ /g,"_");
        // Quitamos acentos y "ñ". Fijate en que va sin comillas el primer parametro
        cadena = cadena.replace(/á/gi, "a");
        cadena = cadena.replace(/é/gi, "e");
        cadena = cadena.replace(/í/gi, "i");
        cadena = cadena.replace(/ó/gi, "o");
        cadena = cadena.replace(/ú/gi, "u");
        cadena = cadena.replace(/ñ/gi, "n");
        cadena = cadena.toUpperCase();
        return cadena;
    };
    Seguimiento_certificadoComponent.prototype.getSolicitud = function () {
        var _this = this;
        this._certService.getSolicitud(this.idSolicitud.value).subscribe(function (response) {
            if (response.exist) {
                _this.sol_encontrada = {
                    id: response.sol['Tramite_Solicitudes::_TRA_ID'],
                    rut: response.sol['Adm_Solicitantes::Sol_RUTDV'],
                    tipo: response.sol['TRACER_Tipo_Solicitud_Completo'],
                    estado: response.sol['Tramite_Solicitudes::TRA_Estado_cert_web_descripcion'],
                    fecha_final: response.sol['TRACER_Fecha_Final'],
                    ingresoCAS: response.sol['TRACER_Ingreso_CAS'],
                    fecha_ingreso: response.sol['Tramite_Solicitudes::TRA_Fecha_Creacion'],
                    dir: response.sol['Tramite_Solicitudes::TRA_Pro_Direccion'],
                    rol: response.sol['Tramite_Solicitudes::TRA_Pro_Rol_Imprimir']
                };
                _this.idEncontrado = true;
                _this._cd.detectChanges();
            }
            else {
                _this._snackBar.open(response.message, 'Cerrar', {
                    duration: 3000,
                });
            }
        }, function (error) {
            var err = JSON.parse(error._body);
            _this._snackBar.open(err.message, 'Cerrar', {
                duration: 3000,
            });
            console.log(error);
        });
    };
    // get_solicitudes() {
    //     this.spinner.show()
    //     this._expService.getSolicitud().subscribe(
    //         response => {
    //             console.log('1');
    //             //this.firstFormGroup.controls['rut'].setValue('');
    //            // this.firstFormGroup.controls['num_solicitud'].setValue('');	
    //             if (response.message) {
    //                 this.cleanData();
    //                 //this.dialog.open(this.openModal);
    //                 alert("El Rut que estas buscando no existe en los registros");
    //                 this.spinner.hide();
    //             } else {
    //                 console.log("quiere mostrar los certificados...")
    //                 /*this.stepper.next();
    //                 this.seguim_cert.num_solicitud = response.num_solicitud ? response.num_solicitud : '';
    //                 this.seguim_cert.rol = response.rol ? response.rol : '';
    //                 this.seguim_cert.tipo = response.tipo ? response.tipo : '';
    //                 this.seguim_cert.direccion = response.direccion ? response.direccion : '';
    //                 this.seguim_cert.fecha_ingreso = response.fecha_ingreso ? response.fecha_ingreso : '';
    //                 this.seguim_cert.estado = response.estado ? response.estado : '';
    //                 this.seguim_cert.descripcion = response.descripcion ? response.descripcion : '';
    //                 */
    //                 /*
    //                 this.solicitudes = response.solicitudes;
    //                 console.log('en ts...');
    //                 console.table(this.solicitudes);
    //                 this.dataSource = this.solicitudes;
    //                 this.length = this.solicitudes.length;
    //                 //console.log ("Length "+this.length);
    //                 this.pageSize = "5";
    //                 this.pageSizeOptions = [5, 10, 25, 100];
    //                 this.dataSource.paginator = this.paginator;
    //                 this.dataSource.sort = this.sort;
    //                 */
    //                this.solicitudes = response.solicitudes;
    //                //this.dataSource = this.solicitudes;
    //                this.dataSource = new MatTableDataSource(this.solicitudes);
    //                setTimeout(() => this.dataSource.paginator = this.paginator )
    //                 this.dataSource.sort = this.sort;
    //                 this.spinner.hide();
    //                 //this.isLinear = true
    //             }
    //         },
    //         error => {
    //             console.log('2');
    //             console.log(error)
    //             this.spinner.hide();
    //         }
    //     )
    // }
    // get_solicitud(sol) {
    //     //  this.cleanData();
    //     //console.table(sol);
    //     console.log("RUT PRUEBA" + this.rut_solic)
    //     console.log("NUMSOL " + sol.num_solicitud)
    //     //var num_solicitud = sol.num_solicitud;
    //     // let num_solicitud = numero;
    //     this.spinner.show()
    //     this._expService.getCert(this.rut_solic, sol.num_solicitud).subscribe(
    //         response => {
    //             console.log(response);
    //             if (response.message) {
    //                 this.cleanData();
    //                 alert("El número de solicitud que estas buscando no existe en los registros");
    //                 this.spinner.hide();
    //             } else {
    //                 this.seguim_cert.num_solicitud = response.informacion.num_solicitud ? response.informacion.num_solicitud : '';
    //                 this.seguim_cert.rol = response.informacion.rol ? response.informacion.rol : '';
    //                 this.seguim_cert.tipo = response.informacion.tipo ? response.informacion.tipo : '';
    //                 this.seguim_cert.direccion = response.informacion.direccion ? response.informacion.direccion : '';
    //                 this.seguim_cert.fecha_ingreso = response.informacion.fecha_ingreso ? response.informacion.fecha_ingreso : '';
    //                 this.seguim_cert.estado = response.informacion.estado ? response.informacion.estado : '';
    //                 this.seguim_cert.descripcion = response.informacion.descripcion ? response.informacion.descripcion : '';
    //                 this.seguim_cert.estado_web = response.informacion.estado_web ? response.informacion.estado_web : '';
    //                 this.spinner.hide()
    //                 this.dialog.open(this.openModalCert);
    //             }
    //         },
    //         error => {
    //             console.log(error)
    //             this.spinner.hide();
    //         }
    //     )
    // }
    /*
    ngDoCheck() {
        this.dataSource.paginator = this.paginator;
        //  this.lSolicitud = this.firstFormGroup.get('num_solicitud').value;
    }
    */
    Seguimiento_certificadoComponent.prototype.cleanData = function () {
        this.seguim_cert = { num_solicitud: '', rol: '', tipo: '', direccion: '', fecha_ingreso: null, estado: '', descripcion: '', recordId: '', estado_web: '' };
    };
    Seguimiento_certificadoComponent.prototype.inicio = function () {
        this._router.navigate(['/']);
    };
    Seguimiento_certificadoComponent.prototype.perfil = function () {
        this.dialog.open(PerfilComponent);
    };
    Seguimiento_certificadoComponent.prototype.compare = function (a, b, isAsc) {
        return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
    };
    Seguimiento_certificadoComponent.prototype.applyFilter = function (filterValue) {
        this.dataSource.filter = filterValue.trim().toLowerCase();
        if (this.dataSource.paginator) {
            this.dataSource.paginator.firstPage();
        }
    };
    /*
    sortData(sort: Sort) {
        const data = this.solicitudes.slice();
        if (!sort.active || sort.direction === '') {
            this.dataSource = data;
            this.dataSource.paginator = this.paginator;
        
            return;
        }

        this.dataSource = data.sort((a, b) => {
            const isAsc = sort.direction === 'asc';
            switch (sort.active) {
                case 'solicitud': return this.compare(a.num_solicitud, b.num_solicitud, isAsc);
                case 'rol': return this.compare(a.rol, b.rol, isAsc);
                case 'tipo': return this.compare(a.tipo, b.tipo, isAsc);
                case 'direccion': return this.compare(a.direccion, b.direccion, isAsc);
                case 'fecha_ingreso': return this.compare(a.fecha_ingreso, b.fecha_ingreso, isAsc);
                case 'estado': return this.compare(a.estado, b.estado, isAsc);
                default: return 0;
            }
           
        });
    }
    */
    /*
     pageEvento(event){
         //it will run everytime you change paginator
             this.dataSource.paginator = this.paginator;
          }
          
   
          */
    Seguimiento_certificadoComponent.prototype.logout = function () {
        sessionStorage.removeItem("identity-domCloud");
        sessionStorage.removeItem("token-domCloud");
        this.snackBar.open("Se ha cerrado sesión", "Cerrar", {
            duration: 3000,
        });
        this._router.navigate(['/inicio']);
    };
    return Seguimiento_certificadoComponent;
}());
export { Seguimiento_certificadoComponent };
